'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

let $hidden = $('.promo-item__hidden');
let $btn = $('.promo-item__more-link');
let $text = $('.promo-item__more-text');

function toggleContent () {
	let $this = $(this);
	let $open = $this.prev($hidden);
	let text = $this.hasClass('open') ? 'Regulamin promocji' : 'Pokaż mniej';

	console.log($this, $this.prev($hidden));

	$open.slideToggle('fast');
	$this
		.toggleClass('open')
		.find($text).text(text);
}

// ----------------------------------------
// Public
// ----------------------------------------

function toggleDetails () {
	$btn.on('click', toggleContent);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {toggleDetails};



// WEBPACK FOOTER //
// ./src/js/_modules/promo.js